import { Card, Row, Col, Typography } from 'antd';
const { Text } = Typography;

export const LotSpecifications = ({ lot }) => {
    if (!lot.specifications || lot.specifications.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                No specifications available for this lot.
            </div>
        );
    }

    return (
        <div>
            {lot.specifications.map((specGroup, groupIndex) => (
                <Card 
                    key={groupIndex} 
                    type="inner" 
                    size="small" 
                    title={specGroup.heading}
                    style={{ marginBottom: 16 }}
                >
                    <Row gutter={[16, 16]}>
                        {specGroup.fields.map((field, fieldIndex) => {
                            const fieldKey = Object.keys(field)[0];
                            const fieldValue = field[fieldKey];
                            
                            return (
                                <Col span={24} key={fieldIndex}>
                                    <div style={{ marginBottom: 8 }}>
                                        <Text type="secondary" style={{ fontWeight: '500' }}>
                                            {fieldKey}
                                        </Text>
                                        <div style={{ marginTop: 4, color: '#333' }}>
                                            {fieldValue}
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </Card>
            ))}
        </div>
    );
};